import { useCallback, useRef, useState } from 'react';
import BaseDialog from './BaseDialog';
import Slide from '../Gallery/Slide';
import GalleryDialogSlider from '../Gallery/GalleryDialogSlider';
import makeStyles from '@mui/styles/makeStyles';
import LoadingSpinner from '../LoadingSpinner';

import "./GalleryDialog.scss";
const useStyles = makeStyles((theme) => ({
    galleryDialog: {
        // [theme.breakpoints.down('md')]: {
            position: "fixed",

            "&.BaseDialog__modal": {
                width: "100%",
                margin: 0,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            },
            "&.GalleryDialog-controlsvisible": {
                "& .GalleryDialogSlider-Controls, & .BaseDialog__closeiconbutton": {
                    opacity: 1,
                    pointerEvents: "initial",
                    transition: "all .2s",
                },
            },
            "& .GalleryDialogSlider-Controls, & .BaseDialog__closeiconbutton": {
                opacity: 0,
                pointerEvents: "none",
            },
            "& .GalleryDialogSlider-Controls": {
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: "hsla(0, 0%, 0%, .8)",
            },
            "& .MuiDialog-scrollBody": {
                overflowY: "hidden",
            }
        // }
    },
    closeButton: {
        [theme.breakpoints.down('md')]: {
            display: "none",
        }
    },
    galleryDialogImg: {
        maxWdth: "100%",
        maxHeight: "calc(100vh - 200px)",
        objectFit: "contain",
        
        [theme.breakpoints.down('md')]: {
            maxHeight: "100vh",
        }
    }
}));

export default function GalleryDialogLazy({ reloadImage, handleClose, onImageChange, open, images, currentImageId = null}) {
    const classes = useStyles();
    
    const [imagesLoadState, setImagesLoadState] = useState(Object.fromEntries(images.map((image, i) => [i, false])));
    const [imagesShouldLoadState, setImagesShouldLoadState] = useState(Object.fromEntries(images.map((image, i) => [
        i, 
        image.id === currentImageId || (currentImageId === null && i === 0)
    ])));

    const activeIndex = images.findIndex(image => {
        console.log("currentImageId", currentImageId, typeof currentImageId);
        console.log("image.id", image.id, typeof image.id);
        return image.id === currentImageId
    });

    console.log("activeIndex", activeIndex);

    const [controlsVisible, setControlsVisible] = useState(true);

    console.log("imageloadstate", imagesLoadState);
    console.log("imagesShouldLoadState", imagesShouldLoadState);
    console.log("currentImageId", currentImageId);
    console.log("images", images);
    function handleImageLoad(i) {
        setImagesLoadState((prevState) => ({
            ...prevState,
            [i]: true,
        }));

        adaptContainerToSlide(emblaContainerRef.current, activeIndex);
    }

    function handleControlsToggle(e) {
        // only hide the controls, if the click was NOT inside the controls
        if(e.target.closest(".GalleryDialogSlider-Controls") === null)
            setControlsVisible(!controlsVisible);
    }
    
    function renderGalleryMeta(slideIndex) {
        return (
            images[slideIndex]?.description && (
                <div style={{
                    padding: "1rem 2.5rem 0",
                    textAlign: "center",
                }}>
                    {images[slideIndex].description}
                </div>
            )
        )
    }
    
    const handleOnSlideChange = useCallback((slideIndex) => {
        onImageChange?.(images[slideIndex]);
        setImagesShouldLoadState((prevState) => ({
            ...prevState,
            [slideIndex]: true,
        }))
    }, [images, onImageChange]);

    const _handleClose = useCallback(() => {
        setImagesShouldLoadState(Object.fromEntries(Object.entries(imagesShouldLoadState).map(([i]) => [i, false])));
        handleClose();
    }, [handleClose, imagesShouldLoadState]);

    const rootRef = useRef();
    const emblaContainerRef = useRef();

    return (
        <div ref={rootRef}>
        <BaseDialog 
            handleClose={_handleClose} 
            open={open} 
            className={["GalleryDialog", classes.galleryDialog, controlsVisible ? "GalleryDialog-controlsvisible" : ""].join(" ")}
            onClick={handleControlsToggle}
        >
            <GalleryDialogSlider
                initialSlideIndex={images.findIndex(image => image.id === currentImageId)}
                renderMeta={renderGalleryMeta}
                onSlideChange={handleOnSlideChange}
                containerRef={emblaContainerRef}
            >
                {images.map((image, i) => {
                    return (
                    <Slide className="GalleryDialog__slide" key={i} style={{
                        display: "flex",
                        justifyContent: "center",
                    }}>
                        {imagesShouldLoadState[i] ? (
                            <>
                                {!imagesLoadState[i] ? (
                                    <div className="GalleryDialog__loadingspinner">
                                        <LoadingSpinner />
                                    </div>
                                ):""}
                                <img 
                                    className={`${classes.galleryDialogImg} GalleryDialog__image ${!imagesLoadState[i] ? "GalleryDialog__image--loading" : ""}`} 
                                    src={image.src} alt={image.title} 
                                    onLoad={() => handleImageLoad(i)}
                                    onError={() => {
                                        setImagesLoadState({
                                            ...imagesLoadState,
                                            [i]: false,
                                        });
                                        reloadImage(image);
                                    }} 
                                />
                            </>
                        ):""}
                    </Slide>
                )
                })}
            </GalleryDialogSlider>
        </BaseDialog>
        </div>
    );
}

function adaptContainerToSlide(containerEl, index) {
    // const heights = [...containerEl.querySelectorAll('.GalleryDialog__slide')].map((el) => {
    //     const img = el.querySelector('img');
    //     return img?.height;
    // });

    // containerEl.style.height = `${heights[index]}px`;
}